import { render, staticRenderFns } from "./HideMenus.vue?vue&type=template&id=b1234e88&scoped=true"
import script from "./HideMenus.vue?vue&type=script&lang=js"
export * from "./HideMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1234e88",
  null
  
)

export default component.exports